import classNames from 'classnames';
import React, { ReactNode } from 'react';

export const IntentIntro = ({ children, className = 'mb-3' }: { children: ReactNode; className?: string }) => {
  return <p className={classNames('text-lg text-grey-6', className)}>{children}</p>;
};
